(function () {
  'use strict';

  /**
   * <availability-carousel>
   *
   * Auto-advances through its .availability-carousel__item children one at
   * a time (only one is ever un-hidden), syncing the optional pagination
   * dots. Rendered by the "Availability" block (see snippets/product.liquid's
   * 'availability' case) from sibling "Message disponibilité" blocks.
   *
   * Respects prefers-reduced-motion (no timer at all, first item stays
   * static) and pauses on hover/focus. Items/dots here are decorative,
   * non-interactive content, so focus-pause is currently a no-op in
   * practice — wired up anyway so it works for free if a dot or item
   * ever becomes a real focusable control.
   */
  customElements.get('availability-carousel') ||
    customElements.define(
      'availability-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.availability-carousel__item'));
          this.dots = Array.from(this.querySelectorAll('.availability-carousel__dot'));
          this.speed = Number(this.dataset.speedMs) || 4000;
          this.index = 0;

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.items.length < 2 || reducedMotion) return;

          this.boundPause = this.pause.bind(this);
          this.boundResume = this.resume.bind(this);

          this.addEventListener('mouseenter', this.boundPause);
          this.addEventListener('mouseleave', this.boundResume);
          this.addEventListener('focusin', this.boundPause);
          this.addEventListener('focusout', this.boundResume);

          this.resume();
        }

        disconnectedCallback() {
          this.pause();
          this.removeEventListener('mouseenter', this.boundPause);
          this.removeEventListener('mouseleave', this.boundResume);
          this.removeEventListener('focusin', this.boundPause);
          this.removeEventListener('focusout', this.boundResume);
        }

        resume() {
          if (this.timer) return;
          this.timer = setInterval(() => this.advance(), this.speed);
        }

        pause() {
          clearInterval(this.timer);
          this.timer = null;
        }

        advance() {
          this.show((this.index + 1) % this.items.length);
        }

        show(nextIndex) {
          this.items[this.index].hidden = true;
          this.dots[this.index]?.classList.remove('is-active');

          this.index = nextIndex;

          this.items[this.index].hidden = false;
          this.dots[this.index]?.classList.add('is-active');
        }
      }
    );
})();
